/**
 * `DELETE /api/files/**` cere DBEST/ADMIN (`SecurityConfiguration:282`), dar
 * `PhotoUploadField` e folosit si de PROFESOR (in `WasteCollectionFormPage`). Azi profesorul
 * primeste 403 pe stergerea din storage si vrea totusi sa scoata poza din formular -- asta ramane
 * comportamentul dorit (decizie S0, 17.09, FE-M2): blobul orfan la un 403 e acceptat, nu se
 * deschide DELETE-ul pentru profesori acum.
 *
 * Extrasa din `PhotoUploadField.removePhoto` ca sa fie testabila fara jsdom (`deleteFile` e
 * injectat, nu importat direct) -- acelasi tipar ca reducer-ul `PhotoPicker`.
 */
export interface RezultatEliminareFotografie {
    urls: string[];
    stergereaDinStorageAEsuat: boolean;
}

export async function eliminaFotografia(
    deleteFile: (url: string) => Promise<void>,
    urls: string[],
    index: number
): Promise<RezultatEliminareFotografie> {
    const url = urls[index];

    let stergereaDinStorageAEsuat = false;
    try {
        await deleteFile(url);
    } catch (error) {
        stergereaDinStorageAEsuat = true;
        console.error('Fotografia n-a putut fi stearsa din storage (blob orfan acceptat):', error);
    }

    return {
        urls: urls.filter((_, i) => i !== index),
        stergereaDinStorageAEsuat,
    };
}
